import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

export const FigmaSectionTitle = ({
  title,
  subtitle,
  href,
  linkLabel = 'View All',
  align = 'left',
}) => {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  const borderStyle = align === 'center' ? '' : 'border-l-4 border-amber-500 pl-3';

  return (
    <div className={`flex flex-col gap-2 ${alignment}`}>
      <div className={`flex items-center gap-3 ${borderStyle}`}>
        {align === 'center' && <span className="racing-stripe h-1.5 w-8 rounded-full mr-2" />}
        <h2 className="font-display text-2xl font-bold uppercase tracking-wide text-foreground sm:text-3xl">
          {title}
        </h2>
        {align === 'center' && <span className="racing-stripe h-1.5 w-8 rounded-full ml-2" />}
      </div>
      {subtitle ? (
        <p className="max-w-2xl text-sm text-muted-foreground sm:text-[15px]">{subtitle}</p>
      ) : null}
      {href ? (
        <Link
          href={href}
          className="inline-flex items-center gap-1 text-sm font-semibold text-amber-600 transition-colors hover:text-amber-700"
        >
          {linkLabel}
          <ChevronRight className="h-4 w-4" />
        </Link>
      ) : null}
    </div>
  );
};
